export default {
    day: '2025-01-19',
    content: {
        village: [
            {
                unlock: 'villageOffering1',
                type: 'bugfix',
                text: '440'
            },
        ],
    }
}
